import { ClientProxy } from '../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../base/models'

export class GetModelCompanyListApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'NetChannelApple/getNetChannelOptionDataList',
      requesterInfo,
    })
  }

  public async getDataList(): Promise<any> {
    return await this.getAsync<any>()
  }
}
